import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import AgHubHeader from "../Header/AgHubHeader";
import Footer from "../Footer/Footer";
import image1 from "../../assets/egypt.jpg";
import image2 from "../../assets/elma.jpg";
import image3 from "../../assets/Frenchitas.jpg";
import image4 from "../../assets/Lays.jpg";
import image5 from "../../assets/Leishi.jpg";
import image6 from "../../assets/Margarita.jpg";
import image7 from "../../assets/Sabritas.jpg";
import image8 from "../../assets/SaudiArabia.jpg";
import image9 from "../../assets/Smiths.jpg";
import image10 from "../../assets/Taiwan.jpg";
import image11 from "../../assets/Tapuchips.jpg";
import image12 from "../../assets/Thailand.jpg";
import { Button, Logo } from "pepsico-ds";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../slices/configSlice";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { useEffect } from "react";
import useLoginFlow from "../../hooks/useLoginFlow";
const imageArray = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
];

// Common styles for the overlay container
const overlayStyles = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 2,
  display: "flex",
  flexDirection: "column",
  width: "90%",
  padding: "16px",
  alignItems: "center",
  gap: "24px",
  borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
  background: "var(--Tokens-Background-Default, #F3F7FD)",
  boxShadow:
    "var(--Elevation-X-Elevation-03, 0px) var(--Elevation-Y-Elevation-03, 2px) var(--Elevation-Blur-Elevation-03, 24px) var(--Elevation-Spread-Elevation-03, 8px) var(--Elevation-Colors-Elevation-03, rgba(0, 92, 188, 0.12))",
  height: "auto", // Set height to auto to fit both cards
  maxHeight: "80vh", // Optional: limit max height to avoid overflow
  overflow: "auto", // Allow scrolling if content exceeds height
  scrollbarWidth: "none", // Firefox: Hide scrollbar
  "&::-webkit-scrollbar": {
    display: "none", // Webkit: Hide scrollbar
  },
};

// Common styles for the card components
const cardStyles = {
  display: "flex",
  padding: "16px",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  borderRadius: "8px",
  backgroundColor: "#FBFCFE",
  boxShadow: "0px 0px 24px rgba(0, 92, 188, 0.08)",
  flexShrink: 0,
  width: "100%", // Ensure card fills the width
};

export default function MobileView() {
  const { switchToInternal, switchToExternal } = useLoginFlow();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#EFF5FC",
        flexShrink: 0,
        justifyContent: "center",
        gap: "24px",
      }}
    >
      <AgHubHeader />

      {/* Background Grid */}
      <main
        style={{
          flex: 1,
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)", // 3 images per row
          gap: "16px", // Spacing between each image box
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {imageArray.map((image, index) => (
          <Box
            key={index}
            sx={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "8px",
              width: "100%",
              height: "150px", // Adjust height for each image box
              opacity: 0.3, // Adjust opacity as needed
            }}
          />
        ))}
      </main>

      {/* Overlay Component */}
      <Box sx={overlayStyles}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "24px", sm: "28px", md: "32px" },
              lineHeight: { xs: "32px", sm: "36px", md: "42px" },
              textAlign: "center",
            }}
          >
            Welcome to the PepsiCo’s Agriculture Experience
          </Typography>
        </Box>

        {/* First Card */}
        <Box sx={cardStyles}>
          <Logo
            colorStyle="color"
            logoType="pepsicoSymbol"
            style={{ width: 64, height: 64 }}
          />
          <Box sx={{ textAlign: "center" }}>
            <Typography
              sx={{
                color: "#3A3A3A",
                fontFamily: "Inter",
                fontSize: "18px",
                fontWeight: 700,
                lineHeight: "28px",
              }}
            >
              PepsiCo employee
            </Typography>
            <Typography
              sx={{
                color: "#3A3A3A",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              Sign in using PepsiCo Single Sign On (SSO)
            </Typography>
          </Box>
          <Button
            size="large"
            text="Sign in"
            variant="primary"
            onClick={switchToInternal}
          />
        </Box>

        {/* Second Card */}
        <Box sx={cardStyles}>
          <Avatar sx={{ bgcolor: "#B2CAEA", width: 40, height: 40 }}>
            <PersonOutlinedIcon color="primary" />
          </Avatar>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              sx={{
                color: "#3A3A3A",
                fontFamily: "Inter",
                fontSize: "18px",
                fontWeight: 700,
                lineHeight: "28px",
              }}
            >
              External Partners
            </Typography>
            <Typography
              sx={{
                color: "#3A3A3A",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              Sign In Using Your PepsiCo External Partners Credentials
            </Typography>
          </Box>
          <Button
            size="large"
            text="Sign in"
            variant="primary"
            onClick={switchToExternal}
          />
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}
